/**
 * Feature flags configuration
 * Change these values to enable/disable features
 */
export const FEATURES = {
  /**
   * Require invite code during registration
   * Set to false on the event day to allow registration without invite code
   */
  REQUIRE_INVITE_CODE: true, // ← Changed back to true
}
